import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const EmbeddedMessage = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M5.77778 3C4.79594 3 4 3.80589 4 4.8C4 5.79411 4.79594 6.6 5.77778 6.6H18.2222C19.2041 6.6 20 5.79411 20 4.8C20 3.80589 19.2041 3 18.2222 3H5.77778ZM4 11.1C4 9.60883 5.19391 8.4 6.66667 8.4H17.3333C18.8061 8.4 20 9.60883 20 11.1V12.9C20 14.3912 18.8061 15.6 17.3333 15.6H6.66667C5.19391 15.6 4 14.3912 4 12.9V11.1ZM5.77778 17.4C4.79594 17.4 4 18.2059 4 19.2C4 20.1941 4.79594 21 5.77778 21H18.2222C19.2041 21 20 20.1941 20 19.2C20 18.2059 19.2041 17.4 18.2222 17.4H5.77778Z"
      fill={getColor(color, isColorInherited)}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SvgIcon>
);
